import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00251 = new TileLayer({
  title: 'Máscara 20050904',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050904l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00251.setVisible(false);

const layer00250 = new TileLayer({
  title: 'Máscara 20050920',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050920l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00250.setVisible(false);
 
const layer00249 = new TileLayer({
  title: 'Máscara 20050928',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050928l7etm202_34_GRN1_inun', format: formatoPNG},
    gutter: 200,
  })
});
layer00249.setVisible(false);

const layer00248 = new TileLayer({
  title: 'Máscara 20051006',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20051006l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00248.setVisible(false);
  
const layer00247 = new TileLayer({
  title: 'Máscara 20051217',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20051217l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00247.setVisible(false);

const layer00246 = new TileLayer({
  title: 'Máscara 20060102',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060102l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00246.setVisible(false);
 
const layer00245 = new TileLayer({
  title: 'Máscara 20060118',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060118l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00245.setVisible(false);

const layer00244 = new TileLayer({
  title: 'Máscara 20060211',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060211l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00244.setVisible(false);

const layer00243 = new TileLayer({
  title: 'Máscara 20060227',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060227l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00243.setVisible(false);

const layer00242 = new TileLayer({
  title: 'Máscara 20060408',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060408l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00242.setVisible(false);

const layer00241 = new TileLayer({
  title: 'Máscara 20060603',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060603l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00241.setVisible(false);

const layer00240 = new TileLayer({
  title: 'Máscara 20060611',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060611l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00240.setVisible(false);

const layer00239 = new TileLayer({
  title: 'Máscara 20060705',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060705l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00239.setVisible(false);

const layer00238 = new TileLayer({
  title: 'Máscara 20060713',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060713l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00238.setVisible(false);

const layer00237 = new TileLayer({
  title: 'Máscara 20060721',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060721l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00237.setVisible(false);

const layer00236 = new TileLayer({
  title: 'Máscara 20060806',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060806l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00236.setVisible(false);

const layer00235 = new TileLayer({
  title: 'Máscara 20060822',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060822l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00235.setVisible(false);
 
const layer00234 = new TileLayer({
  title: 'Máscara 20060830',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20060830l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00234.setVisible(false);

export const grupoCapa01_16 = new LayerGroup({
  title: 'Ciclo Hidrológico 2005-2006',
  fold: 'close',
  layers: [layer00234, layer00235, layer00236, layer00237, layer00238, layer00239, layer00240, layer00241, layer00242, layer00243, layer00244, layer00245, layer00246, layer00247, layer00248, layer00249, layer00250, layer00251]
});